module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-7-m1.4dfe9141.jpg";